export const gameOver = process.env.REACT_APP_GAME_FINISHED === 'true';